<template>
  <div id="section--datos">
    <section v-if="idUser !== idBlock">
      <div class="card card-custom">
        <div class="card-body">
          <h3 class="mt-4 mb-3 title-custom">Datos del vehículo</h3>
          <p class="ml-3">
            En caso de que la diferencia del kilometraje sea
            <span class="fw-bold">mayor al 5%</span> se penalizará con
            <span class="fw-bold">30 puntos</span> de deducible
          </p>
          <div class="d-flex flex-wrap">
            <div class="form-group col-lg-3 col-md-6">
              <label
                class="label-custom"
                title="Recuerda que si llegara a existir un aumento de kilometraje mayor al 5% en la inspección, podría cambiar el costo de la póliza."
                >Kilometraje <i class="fas fa-exclamation-circle"></i
              ></label>
              <input
                type="text"
                min="1000"
                name="km"
                v-model="km"
                class="form-control"
                @keyup="(e) => validateKm(e)"
                required
                @blur="numberFormat"
              />
              <small class="text-danger">{{ this.kmMessage }}</small>
            </div>

            <div class="form-group col-lg-3 col-md-6">
              <label class="label-custom">Marca</label>
              <!-- :value="data.marca || ''" -->
              <v-select
                label="MARCA"
                :options="apistate.marcas"
                @option:selected="handleMarca"
                :value="marca"
                required
              >
                <div slot="no-options">No se encontraron coincidencias.</div>
              </v-select>
            </div>

            <div class="form-group col-lg-3 col-md-6">
              <label class="label-custom">Modelo</label>
              <v-select
                :value="modelo || ''"
                :options="apistate.modelos"
                :disabled="!marca"
                @option:selected="handleModelo"
                required
              >
                <div slot="no-options">No se encontraron coincidencias.</div>
              </v-select>
            </div>

            <div class="form-group col-lg-3 col-md-6">
              <label class="label-custom">Submarca</label>
              <v-select
                :value="submarca || ''"
                :disabled="!modelo"
                :options="apistate.submarcas"
                label="VERSION"
                @option:selected="handleSubmarca"
                required
              >
                <div slot="no-options">No se encontraron coincidencias.</div>
              </v-select>
            </div>

            <div class="form-group col-lg-6 col-md-6">
              <label class="label-custom">Versión</label>
              <select
                name="version"
                class="form-control"
                v-model="version"
                :disabled="!submarca"
                @change="changeVersion"
                required
              >
                <option value="">-- Selecciona</option>
                <!-- :selected="data.version == version.LATINO" -->
                <option
                  :value="version.LATINO"
                  v-for="(version, i) in versiones"
                  :key="i"
                >
                  {{ version.VEHICULO }}
                </option>
              </select>
            </div>

            <div class="form-group col-lg-3 col-md-6">
              <label class="label-custom">Código postal</label>
              <input
                type="number"
                name="cp"
                class="form-control"
                @keyup="handleCP"
                required
              />
              <small class="text-danger" v-if="malformedCP"
                >Código postal incorrecto</small
              >
            </div>

            <div class="form-group col-lg-3 col-md-6">
              <label class="label-custom">Estado</label>
              <input
                type="text"
                name="estado"
                class="form-control"
                disabled
                :value="estado"
                required
              />
            </div>

            <div class="form-group col-lg-3 col-md-6" style="display: none">
              <label class="label-custom">Periodo de vigencia</label>
              <select
                name="fecha_vigencia_ini"
                class="form-control"
                v-model="selectPeriodo"
                required
              >
                <option value="">-- Seleccione</option>
                <option
                  :value="vigencia.DIAS"
                  v-for="(vigencia, v) in vigencias"
                  :key="v"
                  :selected="vigencia.DIAS == 365"
                >
                  {{ vigencia.VIGENCIA }}
                </option>
              </select>
            </div>

            <div
              class="form-group col-lg-3 col-md-6"
              v-if="selectPeriodo > 365"
            >
              <label class="label-custom">Periodo multianual</label>
              <select
                name="periodo_multianual"
                class="form-control"
                v-model="multianual"
                required
              >
                <option value="">-- Seleccione</option>
                <option
                  :value="multianual.DIAS"
                  v-for="(multianual, index) in multianuales"
                  :key="index"
                >
                  {{ multianual.DIAS / 365 }} años
                </option>
              </select>
            </div>

            <div class="form-group col-lg-3 col-md-6">
              <label class="font-label">Inicio vigencia</label>
              <datepicker
                name="vig_ini"
                input-class="form-control bg-white text-center"
                format="yyyy/MM/dd"
                placeholder="aaaa/mm/dd"
                v-model="iniDate"
                :language="es"
                :disabled-dates="disabledDatesVigencia.inicio"
                :typeable="true"
                required
              />
            </div>

            <div class="form-group col-lg-3 col-md-6">
              <label class="font-label">Fin de vigencia</label>
              <datepicker
                name="vig_fin"
                input-class="form-control text-center"
                format="yyyy/MM/dd"
                placeholder="aaaa/mm/dd"
                :value="finVigencia"
                disabled
                :disabled-dates="disabledDatesVigencia.fin"
              />
            </div>

            <div
              class="form-group col-lg-3 col-md-6"
              v-if="sumasOptions.length > 0"
            >
              <label class="label-custom">Tipo de Suma Asegurada</label>
              <select
                v-model="tipoValorSuma"
                @change="assignSumas"
                class="form-control"
              >
                <option value="">--- Seleccionar</option>
                <option
                  v-for="(suma, i) in sumasOptions"
                  :key="i"
                  :value="suma.TIPOVALOR"
                  >{{ suma.NOMBRE }}</option
                >
              </select>
            </div>

            <div
              class="form-group col-lg-3 col-md-6"
              v-if="tipoValorSuma !== 'VC' && tipoValorSuma !== ''"
            >
              <label class="label-custom">
                {{
                  tipoValorSuma === "VO"
                    ? "Valor Convenido"
                    : "Valor de la factura"
                }}
              </label>
              <input
                type="text"
                name="monto_factura"
                class="form-control"
                @blur="numberFormat"
                @keyup="validateFactura"
                v-model="valorFactura"
                :required="!(fechaFactura === '')"
              />
              <small
                class="text-bold"
                v-if="
                  superiorSuma !== 0 &&
                    inferiorSuma !== 0 &&
                    tipoValorSuma === 'VO'
                "
                >S.A. Min. ${{ inferiorSumaFormat }} - S.A. Max. ${{
                  superiorSumaFormat
                }}</small
              >
              <br />
              <small class="text-danger" v-if="errorFactura"
                >Monto no válido</small
              >
            </div>

            <div
              class="form-group col-lg-3 col-md-6"
              v-if="tipoValorSuma === 'VF'"
            >
              <label class="label-custom">Fecha de la factura</label>
              <input
                type="date"
                class="form-control"
                name="fecha_factura"
                @keyup="validateFechaFactura"
                v-model="fechaFactura"
                max="9999-12-31"
                :required="valorFactura > 0"
              />
              <small class="text-danger" v-if="errorFechaFactura"
                >La fecha no puede ser mayor de 60 días</small
              >
            </div>
          </div>
        </div>
        <div class="card-body">
          <h3 class="mt-4 mb-3 title-custom">Datos del conductor habitual</h3>

          <p class="mb-4 ml-3">
            Por favor revisa que toda la
            <span class="fw-bold">información sea correcta</span>
          </p>
          <div class="d-flex flex-wrap">
            <div class="form-group col-lg-4 col-md-4">
              <label class="label-custom">Nombre completo</label>
              <input
                type="text"
                name="fullname"
                class="form-control"
                @keyup="validateString"
                required
              />
            </div>

            <div class="form-group col-lg-4 col-md-4">
              <label class="label-custom">Apellido paterno</label>
              <input
                type="text"
                name="apaterno"
                class="form-control"
                @keyup="validateString"
                required
              />
            </div>

            <div class="form-group col-lg-4 col-md-4">
              <label class="label-custom">Apellido materno</label>
              <input
                type="text"
                name="amaterno"
                class="form-control"
                @keyup="validateString"
                required
              />
            </div>

            <form-builder
              v-for="(item, i) in formAsegurado"
              :key="i"
              :item="item"
            />

            <div class="form-group col-lg-3 col-md-6">
              <label class="label-custom">Fecha de nacimiento</label>
              <input
                type="date"
                name="fecha_nac"
                v-model="fecha_nac"
                class="form-control"
                @keyup="validateBirthdate"
                :max="maxDateNac"
                :min="minDateNac"
                required
              />
              <small class="text-danger" v-if="errorBirthdate"
                >La edad no puede ser menor de 16 ni mayor a 100</small
              >
            </div>

            <div class="form-group col-lg-3 col-md-6">
              <label class="label-custom">Teléfono</label>
              <input
                data-placement="top" 
                title="Recuerda que el teléfono debe ser del contratante."
                type="text"
                name="phone"
                class="form-control"
                @keyup="validateNumber($event, 'phone')"
                @blur="validateNumberBlur"
                @click="openModal('teléfono')"
                required
              />
              <small class="text-danger d-none">Formato incorrecto</small>
            </div>
            <div class="form-group col-lg-3 col-md-6">
              <label class="label-custom">Correo</label>
              <input
                data-placement="top" 
                title="Recuerda que el correo debe ser del contratante."
                type="email"
                name="email"
                class="form-control"
                @blur="validateEmail"
                @click="openModal('correo')"
                required
              />
            </div>
          </div>

          <div class="d-flex flex-wrap">
            <div class="col-md-12">
              <h6 class="fw-bold">IMPORTANTE:</h6>
              <label
                >1) Recuerda que con el
                <span class="fw-bold">kilometraje del automóvil</span> obtendrán
                el mejor precio y grandes beneficios en las coberturas</label
              >
              <label
                >2) Para verificar los datos proporcionados, después de
                contratar el <span class="fw-bold">Seguro Valor Latino</span>,
                enviaremos una liga para que el cliente pueda realizar la
                inspección de su auto. Recuerda que el dato de kilometraje así
                como realizar la inspección correctamente, son imprescindibles
                para respetar los términos y condiciones contratados en la
                póliza en caso de siniestro</label
              >
              <label
                >3) Recuerda que el teléfono y correo solicitados deben ser del contratante.</label
              >
            </div>
          </div>

          <div class="d-flex flex-wrap">
            <div
              v-if="apistate.agentes.length > 0"
              class="form-group col-lg-6 col-md-6 mt-2"
            >
              <label class="label-custom">Agente</label>
              <select
                name="agente"
                class="form-control"
                v-model="agente"
                :disabled="apistate.agentes.length === 1"
                required
              >
                <option
                  v-for="(agente, index) in apistate.agentes"
                  :key="index"
                  :value="agente.psClave_Agente"
                >
                  {{ agente.psNombre_Agente }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="d-flex justify-content-end">
            <button
              class="btn btn-primary btn-rounded"
              @click="openModalKM"
            >
              Siguiente
            </button>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<style>
.card-custom {
  border-radius: 60px !important;
  padding: 20px !important;
  box-shadow: 0 10px 20px rgb(0 0 0 / 1%), 0 6px 6px rgb(0 0 0 / 23%) !important;
}

.title-custom {
  color: #003b71 !important;
  font-weight: bold !important;
  margin-left: 15px !important;
}

.label-custom {
  font-size: 12px !important;
  color: #757575 !important;
}

.message-form {
  font-size: 12px !important;
  font-weight: bold !important;
  margin-left: 15px !important;
  margin-right: 15px !important;
}

.btn-rounded {
  border-radius: 30px !important;
  font-size: 12px !important;
  padding-left: 20px !important;
  padding-right: 20px !important;
}

.title-ul {
  font-size: 15px !important;
  font-weight: bold !important;
  color: #757575 !important;
}

li {
  font-size: 12px !important;
  text-align: justify !important;
  color: #757575 !important;
}

.text-bold {
  font-weight: bold !important;
}
</style>

<script>
import FormBuilder from "../../../../componentes/form/Builder.vue";
import { format, validate, form } from "../../../../assets/helpers";
import Datepicker from "vuejs-datepicker";
import { es } from "vuejs-datepicker/dist/locale";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  components: {
    FormBuilder,
    Datepicker,
    vSelect,
  },
  props: {
    data: Object,
    apistate: {},
    payload: Object,
    modalkm: Boolean,
    modalEmailTel: Boolean,
    tel_email: String
  },
  data() {
    return {
      idUser: localStorage.getItem("userId"),
      idBlock: "10059",
      iniDate: new Date(),
      es: es,
      errorBirthdate: false,
      errorFactura: false,
      errorFechaFactura: false,
      maxFactura: 1500000,
      km: null,
      kmMessage: "",
      fecha_nac: null,
      universe: this.payload ? this.payload.universe : null,
      universe2: this.payload ? this.payload.universe2 : null,
      selectPeriodo: 365,
      multianual: null,

      // Datos seleccionados del usuario
      marca: this.payload ? this.payload.marca : null,
      modelo: this.payload ? this.payload.modelo : null,
      submarca: this.payload ? this.payload.submarca : null,
      version: null,
      cp: null,
      estado: this.payload ? this.payload.estado : null,
      municipio: null,
      delegacion: null,
      vigencias: this.apistate.vigencias || [],
      multianuales: this.apistate.multianuales || [],

      valorFactura: "",
      fechaFactura: "",

      // Validacion
      malformedCP: false,
      autoDelAnio: false,
      disabledDatesVigencia: {
        inicio: {
          to: new Date(),
        },
        fin: {
          to: new Date(),
        },
      },
      formAsegurado: [
        {
          label: "Sexo",
          name: "sexo",
          element: "select",
          class: "col-lg-3 col-md-6 label-custom",
          required: true,
          options: [
            {
              label: "-- Seleccione",
              value: "",
            },
            {
              label: "Femenino",
              value: "F",
            },
            {
              label: "Masculino",
              value: "M",
            },
          ],
        },
      ],

      idCotizacion: undefined,
      agente: "",
      sumasOptions: [],
      tipoValorSuma: "",
      superiorSuma: 0,
      inferiorSuma: 0,
      superiorSumaFormat: 0,
      inferiorSumaFormat: 0,

      minDateNac: "",
      maxDateNac: "",
    };
  },

  methods: {
    openModal(value){
      console.log('entra');
      this.$emit('update:tel_email', value);
      this.$emit('update:modalEmailTel', true);
      setTimeout(() => {
        this.$emit('update:modalEmailTel', false);
      }, 2500)
    },
    openModalKM(){
      this.$emit('update:modalkm', true);
    },
    validateKm(e) {
      if (e.target.value < 1000) {
        this.kmMessage = "El kilometraje no puede ser menor a 1000";
      } else {
        this.kmMessage = "";
      }

      if (!this.validarKilometraje()) {
        return this.$swal(
          "Atención",
          "Gracias por vivir la experiencia Valor Latino, hemos detectado que tu unidad tiene un km mayor a lo permitido recorridos por año, monto mayor a lo permitido en este producto, es por ello que te invitamos a cotizar en Auto Latino"
        );
      }
    },
    handleNavigation() {
      const fakeForm = document.querySelector("#section--datos");

      if (
        !form.validate(fakeForm) ||
        parseInt(this.km) <= 0 ||
        this.errorFechaFactura ||
        this.errorFactura ||
        this.kmMessage !== ""
      ) {
        return this.$swal("Error", "Todos los campos son obligatorios");
      }

      if (
        (this.tipoValorSuma === "VF" || this.tipoValorSuma === "VO") &&
        this.valorFactura === ""
      ) {
        this.errorFactura = true;
        return this.$swal("Error", "Todos los campos son obligatorios");
      }

      const versiones = this.apistate.submarcas.filter(
        (sub) => sub.VERSION == this.submarca
      );

      const versionText = versiones[0].VEHICULOS.find(
        (veh) => veh.LATINO === this.version
      );

      const payload = form.build(fakeForm);
      payload.marca = this.marca;
      payload.modelo = this.modelo;
      payload.submarca = this.submarca;
      payload.version = this.version;
      payload.versionText = versionText.VEHICULO;
      payload.universe = this.universe;
      payload.universe2 = this.universe2;
      payload.estado = this.estado;
      payload.municipio = this.municipio;
      payload.delegacion = this.delegacion;
      payload.tipoVigencia = document
        .querySelector("[name='fecha_vigencia_ini']")
        .selectedOptions[0].innerText.trim();
      payload.agente = this.agente;
      payload.tipoValor = this.tipoValorSuma;

      if (!this.errorBirthdate) {
        this.$emit("onChangeStep", 2, "datos", payload);
      }
    },
    handleMarca({ MARCA }) {
      this.marca = MARCA;
      // Reset on change
      if (this.apistate.modelos) {
        this.apistate.modelos = [];
        if (this.payload) {
          this.payload.modelo = null;
        }
        this.modelo = false;
      }
      if (this.apistate.submarcas) {
        this.apistate.submarcas = [];
        if (this.payload) {
          this.payload.submarca = "";
        }
        this.submarca = false;
      }

      this.getModelos();
    },
    handleModelo(modelo) {
      const thisYear = new Date().getFullYear();
      this.autoDelAnio = thisYear == modelo;
      this.modelo = modelo;

      // Reset on change
      if (this.apistate.submarcas) {
        this.apistate.submarcas = [];
        if (this.payload) {
          this.payload.submarca = "";
        }
        this.submarca = false;
      }

      if (!this.validarKilometraje()) {
        return this.$swal(
          "Error",
          "Gracias por vivir la experiencia Valor Latino, hemos detectado que tu unidad tiene un km mayor a lo permitido recorridos por año, monto mayor a lo permitido en este producto, es por ello que te invitamos a cotizar en Auto Latino"
        );
      }

      this.getSubmarca();
    },
    validarKilometraje() {
      const thisYear = new Date().getFullYear();
      var anios = thisYear - this.modelo;

      anios = anios <= 0 ? 1 : anios;

      //this.km = this.km < 1000 ? 1000 : this.km;

      var kmMaximo = anios * 35000;

      if (this.km !== undefined && this.km !== "") {
        if (this.km.replace(",", "") > kmMaximo) {
          if (this.apistate.modelos) {
            this.modelo = "";
            if (this.apistate.submarcas) {
              this.apistate.submarcas = [];
              if (this.payload) {
                this.payload.submarca = "";
              }
              this.submarca = false;
            }
          }

          return false;
        }
      }
      return true;
    },
    handleSubmarca({ VERSION }) {
      this.submarca = VERSION;
    },
    numberFormat(e) {
      const cleaned = format.number(e.target.value);
      e.target.value = format.money(cleaned, false);
    },
    validateBirthdate(e) {
      const edad = this.getAge(e.target.value);

      if (edad < 16 || edad > 100) {
        this.errorBirthdate = true;
        return false;
      }

      this.errorBirthdate = false;
      return true;
    },
    getAge(dateString) {
      const today = new Date();
      const birthDate = new Date(dateString);
      let age = today.getFullYear() - birthDate.getFullYear();
      const m = today.getMonth() - birthDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      return age;
    },
    validateFactura(e) {
      if (
        format.number(e.target.value) > this.maxFactura &&
        this.tipoValorSuma === "VF"
      ) {
        return (this.errorFactura = true);
      }

      if (
        this.tipoValorSuma === "VO" &&
        (format.number(e.target.value) < this.inferiorSuma ||
          format.number(e.target.value) > this.superiorSuma)
      ) {
        return (this.errorFactura = true);
      }
      this.errorFactura = false;
    },
    validateFechaFactura(e) {
      const incomingStringDate = e.target.value;

      if (!incomingStringDate) {
        return;
      }

      const inputDate = new Date(format.date(e.target.value, "mm-dd-aaaa"));
      const d = new Date();
      const max = new Date(d.getFullYear(), d.getMonth(), d.getDate() - 60);
      if (inputDate > d || inputDate < max) {
        return (this.errorFechaFactura = true);
      }
      this.errorFechaFactura = false;
    },
    handleCP(e) {
      const cp = e.target.value;
      this.estado = "";

      if (isNaN(cp)) {
        this.$swal.fire({
          title: "Sólo números son permitidos",
        });
        e.target.value = cp.slice(0, -1);
        return;
      }

      this.malformedCP = false;

      if (cp.length === 5) {
        this.cp = cp;
        this.getAddress();
      } else if (cp.length > 5) {
        this.malformedCP = true;
      }
    },
    validateString(e) {
      const target = e.target.value;

      if (!validate.string(target)) {
        this.$swal.fire({
          title: "Sólo caracteres alfabéticos",
        });
        e.target.value = target.slice(0, -1);
        return;
      }
    },
    validateNumber(e, type = null) {
      const target = e.target.value;
      if (target.length < 10) return;

      if (type == "phone" && target.length > 10) {
        e.target.value = target.slice(0, -1);
        return;
      }

      const error = (e, remove = false) => {
        e.target.classList.add("input__error");
        e.target.parentElement
          .querySelector("small")
          .classList.remove("d-none");
        if (remove) {
          e.target.value = target.slice(0, -1);
        }
      };

      if (isNaN(target)) {
        return error(e, true);
      }

      if (target.length > 10) {
        return error(e);
      }

      e.target.classList.remove("input__error");
      e.target.parentElement.querySelector("small").classList.add("d-none");
    },
    validateNumberBlur(e) {
      const small = e.target.parentElement.querySelector("small");

      if (!validate.phone(e.target.value)) {
        small.classList.remove("d-none");
        return e.target.classList.add("input__error");
      }

      small.classList.add("d-none");
      e.target.classList.remove("input__error");
    },
    validateEmail(e) {
      const target = e.target.value;

      if (!validate.email(target)) {
        this.$swal.fire({
          title: "No es un email válido",
        });
        e.target.value = "";
        return;
      }
    },
    changeVersion() {
      this.sumasOptions = [];
      this.inferiorSuma = 0;
      this.superiorSuma = 0;
      this.inferiorSumaFormat = 0;
      this.superiorSumaFormat = 0;
      this.tipoValorSuma = "";

      const foundVersion = this.apistate.submarcas.filter(
        (fil) => fil.VERSION === this.submarca
      );
      const foundSumas = foundVersion[0].VEHICULOS.filter(
        (fil) => fil.LATINO === this.version
      );

      this.sumasOptions.push(...foundSumas[0].SUMAS);
    },
    assignSumas() {
      this.valorFactura = "";
      this.errorFactura = false;

      const getSumas = this.sumasOptions.filter(
        (fil) => fil.TIPOVALOR === this.tipoValorSuma
      );

      this.superiorSuma = getSumas[0].SUPERIOR;
      this.inferiorSuma = getSumas[0].INFERIOR;

      this.superiorSumaFormat = format.money(getSumas[0].SUPERIOR, true);
      this.inferiorSumaFormat = format.money(getSumas[0].INFERIOR, true);
    },
    setMaximumDates() {
      const currentlyYear = new Date().getFullYear();

      this.maxDateNac = `${currentlyYear - 16}-12-31`;
      this.minDateNac = `${currentlyYear - 100}-01-01`;
    },
    // Api's
    async getMarcasAutos() {
      if (this.apistate.marcas.length > 0) {
        return;
      }
      const payload = {
        metodo: "GET_MARCAS_CA",
        data: {
          Cotizador: 2,
        },
      };

      const res = await this.$store.dispatch("metodoPost", payload);
      if (res) {
        const marcas = this.$store.getters.getRespuestaREST;
        this.$emit("onApiReady", {
          section: "datos",
          api: "marcas",
          data: marcas,
        });
      }
    },
    async getModelos() {
      if (this.apistate.modelos.length > 0) {
        return;
      }

      const payload = {
        metodo: "GET_MODELOS_CA",
        data: {
          MarcaAuto: this.marca,
          Cotizador: "2",
        },
      };

      const res = await this.$store.dispatch("metodoPost", payload);
      if (res) {
        const dataModelos = this.$store.getters.getRespuestaREST.map(
          (model) => model.MODELO
        );
        const modelos = dataModelos.sort().reverse();
        this.$emit("onApiReady", {
          section: "datos",
          api: "modelos",
          data: modelos,
        });
      }
    },
    async getSubmarca() {
      if (this.apistate.submarcas.length > 0) {
        return;
      }
      const payload = {
        metodo: "GET_SUBMARCA_CA",
        data: {
          MarcaAuto: this.marca,
          ModeloAuto: this.modelo,
          Cotizador: "2",
        },
      };

      const res = await this.$store.dispatch("metodoPost", payload);
      if (res) {
        const submarcas = this.$store.getters.getRespuestaREST;
        this.$emit("onApiReady", {
          section: "datos",
          api: "submarcas",
          data: submarcas,
        });
      }
    },
    async getAddress() {
      if (this.estado) {
        return;
      }
      const payload = {
        metodo: "GET_CP_CA",
        data: {
          cp: this.cp,
        },
      };

      const res = await this.$store.dispatch("metodoPost", payload);
      if (res) {
        const address = this.$store.getters.getRespuestaREST[0];

        if (address !== undefined) {
          this.estado = address.NombreEstado;
          this.municipio = address.NombreMunicpio;
          this.delegacion = address.NombreCiudad;
          this.universe = address.MunUniverse;
          this.universe2 = address.Universe;
        }
      }
    },
    async getVigencias() {
      const payload = {
        metodo: "GET_VIGENCIAS_CA",
      };

      const res = await this.$store.dispatch("metodoPost", payload);
      if (res) {
        const response = this.$store.getters.getRespuestaREST;
        const orderedVigencias = response
          .sort((a, b) => (a.DIAS > b.DIAS ? 1 : b.DIAS > a.DIAS ? -1 : 0))
          .reverse();

        const firstMulti = orderedVigencias.filter(
          (vigencia) => vigencia.DIAS == 730
        );
        const vigencias = orderedVigencias.filter(
          (vigencia) => vigencia.DIAS < 730
        );
        const periodos = [...vigencias, ...firstMulti];

        const multianuales = orderedVigencias.filter(
          (vigencia) => vigencia.DIAS > 365
        );

        this.vigencias = periodos;
        this.multianuales = multianuales;

        this.$emit("onApiReady", {
          section: "datos",
          api: "vigencias",
          data: periodos,
        });

        this.$emit("onApiReady", {
          section: "datos",
          api: "multianuales",
          data: multianuales,
        });
      }
    },
    async getAgentes() {
      if (this.apistate.agentes.length > 0) {
        return;
      }

      const payload = {
        metodo: "OBTENERLISTADOAGENTES",
        data: {
          ClaveAgente: localStorage.getItem("userId"),
        },
      };

      const res = await this.$store.dispatch("metodoPost", payload);
      if (res) {
        const agentes = this.$store.getters.getRespuestaREST;

        this.$emit("onApiReady", {
          section: "datos",
          api: "agentes",
          data: agentes,
        });

        this.agente =
          agentes.length <= 0
            ? localStorage.getItem("userId")
            : agentes[0].psClave_Agente;
      }
    },
    fillData() {
      const {
        marca,
        fecha_nac,
        version,
        fecha_vigencia_ini,
        km,
        agente,
        tipoValor,
        monto_factura,
        fecha_factura,
        submarca,
      } = this.payload;

      this.marca = marca;
      this.submarca = submarca;
      this.version = version;
      this.fecha_nac = fecha_nac;
      this.version = version;
      this.selectPeriodo = fecha_vigencia_ini;
      this.km = km;
      this.agente = agente;
      this.tipoValorSuma = tipoValor;
      this.valorFactura = monto_factura;
      this.fechaFactura = fecha_factura;

      const foundVersion = this.apistate.submarcas.filter(
        (fil) => fil.VERSION === this.submarca
      );
      const foundSumas = foundVersion[0].VEHICULOS.filter(
        (fil) => fil.LATINO === this.version
      );

      this.sumasOptions.push(...foundSumas[0].SUMAS);
    },
  },
  computed: {
    finVigencia() {
      const iniDate = new Date(format.date(this.iniDate, "aaaa/mm/dd"));
      let periodo = null;
      if (this.multianual) {
        periodo = this.multianual;
      } else {
        periodo = this.selectPeriodo || 365;
      }

      return new Date(
        iniDate.getFullYear(),
        iniDate.getMonth(),
        iniDate.getDate() + Number(periodo)
      );
    },
    versiones() {
      if (this.submarca) {
        const versiones = this.apistate.submarcas.filter(
          (sub) => sub.VERSION == this.submarca
        );
        return versiones[0].VEHICULOS;
      }
      return [];
    },
    currentYearModel() {
      const d = new Date();
      const thisYear = d.getFullYear();

      if (this.modelo >= thisYear) {
        return true;
      }

      return false;
    },
  },
  async mounted() {
    this.$emit("onMounted", "datos");
    const d = new Date();

    this.disabledDatesVigencia.inicio.from = new Date(
      d.getFullYear(),
      d.getMonth(),
      d.getDate() + 30
    );

    this.disabledDatesVigencia.inicio.to = new Date(
      d.getFullYear(),
      d.getMonth(),
      d.getDate()
    );

    if (this.payload) {
      this.fillData();
      return;
    }

    this.setMaximumDates();

    Promise.all([
      this.getMarcasAutos(),
      this.getVigencias(),
      this.getAgentes(),
    ]);
  },
};
</script>
